/**
 * RM schema metadata (BMM-backed attribute introspection).
 *
 * @module
 */
export {
  ancestorsOf,
  attributesFor,
  hasRmAttribute,
  hasRmType,
  isAbstractType,
  isDataValueType,
  isSubtypeOf,
  ownAttributesFor,
  RM_META_BMM_VERSION,
  RM_META_GENERATED_AT,
  RM_META_RM_RELEASE,
  RM_META_SCHEMA_NAME,
  RM_META_SOURCES,
  subtypesOf,
  type RmAttributeMeta,
  type RmMultiplicity,
  type SubtypesOptions,
} from "./rm_attributes.ts";
